
export class NewAprovadorDTO  {

    constructor(
        public login?: string,
        public email?: string,
        public senha?: string,
        public auth1?: string,
        public auth2?: string, 
        public candidatura?: any,
    ) {}
 
}